import { render, staticRenderFns } from "./GenericSlider.vue?vue&type=template&id=08ec907e&"
import script from "./GenericSlider.vue?vue&type=script&lang=js&"
export * from "./GenericSlider.vue?vue&type=script&lang=js&"
import style0 from "./GenericSlider.vue?vue&type=style&index=0&id=08ec907e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports